import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-column gap-3 line-height-3" }
const _hoisted_2 = { class: "m-0" }

import Button from "primevue/button";
import Dialog from "primevue/dialog";


export default /*@__PURE__*/_defineComponent({
  __name: 'TrabalhoEmUsoDialog',
  props: {
    visible: { type: Boolean },
    editandoPor: {},
    antesDeAbrir: { type: Boolean }
  },
  emits: ["update:visible", "abrir"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: _ctx.visible,
    draggable: false,
    header: "Trabalho em uso",
    style: { width: '520px' },
    breakpoints: { '575px': '92vw' },
    modal: true,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (emit('update:visible', $event)))
  }, {
    footer: _withCtx(() => [
      (_ctx.antesDeAbrir)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_unref(Button), {
              label: "Voltar",
              severity: "secondary",
              outlined: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:visible', false)))
            }),
            _createVNode(_unref(Button), {
              label: "Abrir para leitura",
              icon: "pi pi-eye",
              autofocus: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('abrir')))
            })
          ], 64))
        : (_openBlock(), _createBlock(_unref(Button), {
            key: 1,
            label: "Entendi",
            autofocus: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('update:visible', false)))
          }))
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.editandoPor || "Outra pessoa"), 1),
          _cache[4] || (_cache[4] = _createTextVNode(" está editando este trabalho no momento. "))
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "m-0" }, " Para evitar conflitos ou perda de alterações, apenas uma pessoa pode editar o trabalho por vez. Essa regra vale para todos os alunos do grupo e para o orientador. ", -1)),
        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "m-0" }, " A edição será liberada automaticamente quando a pessoa sair do trabalho. Se houver perda de conexão, a liberação poderá levar até 2 minutos. ", -1))
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})